<template>
  <div class="text-xs-center">
    <p v-if="error" class="text-danger">{{ error }}</p>
    <img
      v-if="position !== 'bottom' && image"
      :src="image"
      :width="width"
      :class="{clickable: !disabled}"
      @click="pickFile"
    >
    <v-text-field
      v-model="imageName"
      :rules="[v => !!v || 'Dies ist ein Pflichtfeld']"
      :label="label"
      prepend-icon="attach_file"
      @click="pickFile"
      :disabled="disabled"
    />
    <input
      ref="image"
      type="file"
      style="display: none"
      accept="image/*"
      @change="onFilePicked"
      :disabled="disabled"
    >
    <img
      v-if="position === 'bottom' && image"
      :src="image"
      :width="width"
      :class="{clickable: !disabled}"
      @click="pickFile"
    >
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ImageUploader',
  props: {
    width: {
      type: Number,
      default: 400,
    },
    position: {
      type: String,
      default: 'top',
    },
    value: {
      type: String,
      default: 'placeholder.png',
    },
    label: {
      type: String,
      default: 'Logo',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      error: '',
      imageName: '',
      imageUrl: '',
      imageFile: '',
      image: 'placeholder.png',
    };
  },
  watch: {
    value() {
      if (this.value) {
        this.image = 'https://images.ihrespezialisten.at' + this.value;
        this.imageName = this.value;
      } else {
        this.image = null;
        this.imageName = '';
      }
    },
  },
  methods: {
    ...mapActions({
      uploadAdImage: 'ads/uploadImage',
    }),
    pickFile() {
      if (!this.disabled) {
        this.$refs.image.click();
      }
    },
    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        if (!files[0].type.startsWith('image/')) {
          this.error = 'Ungültiges Bildformat ausgewählt!';
          return;
        }

        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf('.') <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', (res) => {
          this.image = res.target.result;
          this.imageFile = files[0];
        });
      }
    },
    doUpload() {
      if (this.imageFile !== '') {
        return this.uploadAdImage(this.imageFile);
      } else {
        return new Promise((resolve) => resolve(this.imageName));
      }
    },
    reset() {
      this.imageName = '';
      this.imageUrl = '';
      this.imageFile = '';
      this.image = 'placeholder.png';
    },
  },
};
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
</style>
